import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

const NewsArticle = () => {
    const { id } = useParams(); 
    const [article, SetArticle] = useState(null); 
    const [loading, SetLoading] = useState(true); 
    const [error, SetError] = useState(null); 

    useEffect(() => {
        if (!id) {
            SetError('ID is missing');
            SetLoading(false);
            return;
        }

        const fetchData = async () => {
            SetLoading(true); 
            try {
                const response = await fetch(`https://haldor-infoapp-test.azurewebsites.net/api/Information/${id}`,{
                    method:'GET'
                });
                if (response.status === 200) {
                    const result = await response.json();
                    SetArticle(result); 
                } else {
                    SetError(`Error: ${response.status}`);
                }
            } catch (err) {
                SetError(`Fetch error: ${err.message}`);
            } finally {
                SetLoading(false); 
            }
        };

        fetchData();
    }, [id]); 
    
    if (loading) {
        return <div>Loading...</div>; 
    }

    if (error) {
        return (
            <div className="error-message">
                <i className="fas fa-exclamation-triangle"></i> {/* Icon */}
                <span>{error}</span>
            </div>
        );
    }
    

    return (
        <div className="article-container">
            <div className='info'>
                <h1>Rubrik: {article.title}</h1>
                <p><strong>Creator:</strong> {article.creator}</p>
                <p><strong>Created on:</strong> {new Date(article.created).toLocaleDateString()}</p>
                <p><strong>Status:</strong> {article.status ? 'Active' : 'Inactive'}</p>
                <p><strong>Text:</strong> {article.text}</p>
                <p><strong>Url:</strong> {article.url}</p>
                <p><strong>Last shown:</strong> {new Date(article.lastShowDate).toLocaleDateString()}</p>
                <span><strong>Skapad:</strong> {new Date(article.created).toLocaleDateString()}</span>
                <span><strong>---Giltlig:</strong> {new Date(article.lastShowDate).toLocaleDateString()}</span>
                
               
                        
               
            </div>
           
            <div className='table'>
                <h1>Anslutna</h1>
                <table className="relationship-table">
                    <thead>
                        <tr>
                            <th>School ID</th>
                            <th>Role</th>
                            <th>Functions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {article.relationships.map((relationship, index) => (
                            <tr key={index}>
                                <td>{relationship.schoolName}</td>
                                <td>{relationship.roleName}</td>
                                <td>{relationship.functionName}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
         
        </div>
    );
};

export default NewsArticle;
